import { blue05 } from '../../../colors/blue';
export var MuiListItemSecondaryAction = {
    styleOverrides: {
        root: {
            '& [class*=MuiButton-root][class*=MuiButton-icon]': {
                '&:focus-visible': { boxShadow: "inset 0 0 0 1px ".concat(blue05) },
            },
        },
    },
};
